import AdminHome from "../../../Components/Admin/AdminHome";

const AdminHomePage = () => {
  return <AdminHome />;
};

export default AdminHomePage;
